import { Component, signal } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel,RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('customer-portal');
  constructor(private readonly router: Router) {
    // Debug router navigation to help diagnose redirect issues
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) console.info('[Router] NavigationStart', e.url);
      if (e instanceof NavigationEnd) console.info('[Router] NavigationEnd', e.urlAfterRedirects);
      if (e instanceof NavigationCancel) console.info('[Router] NavigationCancel', e);
      if (e instanceof NavigationError) console.error('[Router] NavigationError', e.error);
    });
    // also log initial url
    console.info('[Router] initialUrl =', this.router.url);
  }
}
